import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { PayService } from 'src/app/service/pay.service';

function passwordMatchValidator(g: UntypedFormGroup) {
  return g.get('password').value === g.get('confirmPassword').value
    ? null : { 'mismatch': true };
}

@Component({
  selector: 'app-ajouter-gestionnaire',
  templateUrl: './ajouter-gestionnaire.component.html',
  styleUrls: ['./ajouter-gestionnaire.component.css'],
  standalone: false
})
export class AjouterGestionnaireComponent implements OnInit {
  gestionaireForm: UntypedFormGroup;
  gestionaireList: any[];

  constructor(private userService: PayService) { }

  ngOnInit(): void {
    this.ngpartenaireForm();
    this.findPartenaires();
  }

  ngpartenaireForm() {
    this.gestionaireForm = new UntypedFormGroup({
      firstName: new UntypedFormControl('', [Validators.required, Validators.minLength(3)]),
      lastName: new UntypedFormControl('', [Validators.required, Validators.minLength(3)]),
      email: new UntypedFormControl('', [Validators.required, Validators.pattern("[^ @]*@[^ @]*[.][^ @]{2,}")]),
      phone: new UntypedFormControl('', [Validators.required, Validators.pattern("[1-9][0-9]*"), Validators.pattern('(^(65)[0-9]{1}[0-9]{6}|^(69|66|67|64|90)[0-9]{7})$')]),
      password: new UntypedFormControl('', [Validators.required, Validators.pattern('[0-9]{6}')]),
      confirmPassword: new UntypedFormControl('', [Validators.required, Validators.pattern('[0-9]{6}')]),

    }, passwordMatchValidator)
  }

  addGestionaire(formdata) {
    this.userService.ajouterGestionaire(formdata).subscribe(data => {

      this.findPartenaires();
    })

  }

  findPartenaires() {
    this.userService.afficherGestionaires().subscribe((data: any[]) => {
      this.gestionaireList = data;


    })
  }

}
